import { Application } from "../Application";
import { Bootstrapper } from "../Bootstrapper";
import { store } from "../RoutingAndStore";

declare module "../ApplicationAliases" {
    interface ApplicationAliases {
        Redux: typeof store;
    }
}

export class ReduxBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public bootstrap(): void {
        Application.bind("Redux", store);
    }
}
